import { Occupancy } from "../occupancy"
import { AType, EType, summon } from "@silversea-ssc/functional-support"
import { FareCode } from "@silversea-ssc/web-fares-fp"
import { AirParams } from "../air-params"
import { AvailabilityType } from "../availability-type"
import { CruiseCode } from "@ssc-booking/functional-support"

export const FarePriceRequest = summon((F) =>
    F.interface(
        {
            cruiseCode: CruiseCode(F),
            occupancy: Occupancy(F),
            fareCode: FareCode(F),
            suiteCategory: F.nullable(F.string()),
            vsMember: F.nullable(F.boolean()),
            availabilities: F.nonEmptyArray(AvailabilityType(F)),
            air: AirParams(F),
        },
        "FarePriceRequest",
    ),
)

export type FarePriceRequest = AType<typeof FarePriceRequest>
export type FarePriceRequestEncoded = EType<typeof FarePriceRequest>
